import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface GiftVoucherFormState {
    name: string;
    phone: string;
    email: string;
    sendEmail: boolean;
    isGifting: boolean;
    formValid: boolean;
    recipientSelected: boolean;
}

export function createInitialState(): GiftVoucherFormState {
    return {
        name: '',
        phone: '',
        email: '',
        sendEmail: false,
        isGifting: false,
        formValid: false,
        recipientSelected: false,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'gift-voucher-form', resettable: true })
export class GiftVoucherFormStore extends Store<
    GiftVoucherFormState
> {
    constructor() {
        super(createInitialState());
    }
}
